import React, { useState, useRef, useEffect } from "react"
import { Modal, Snackbar, Typography, Paper, TextField, makeStyles, Button } from "@material-ui/core";
import { useParams, Route } from "react-router-dom";
import { makeBooking } from '../firebase/makeBooking';
import Alert from '@material-ui/lab/Alert';

const BookButton = ({ store, events }) => {
  let { eventId, slotId } = useParams();
  const isMounted = useRef(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [memberId, setMemberId] = useState("");

  let nbrOfFree = 0;

  const snackbars = {
    bookingSuccess: {
      text: "Bokning klar",
      severity: 'success',
    },
    bookingFailure: {
      text: "Kunde inte boka",
      severity: 'error',
    }
  }
  const snackbar = useRef();

  useEffect(() => {
    isMounted.current = true;
    return (
      () => {
        isMounted.current = false;
      }
    );
  }, []);

  const handleBook = async (event) => {
    event.preventDefault();

    let slotRef = "";

    events[eventId].slots.map((slot) => {
      if (events[eventId].id === eventId && slot.id === slotId) {
        slotRef = slot.ref
      }
    });

    if (slotRef === "") {
      return;
    }

    const result = await makeBooking(slotRef, memberId);
    if (!isMounted.current) {
      return;
    }
    if (result.success) {
      snackbar.current = snackbars.bookingSuccess;
      handleModalClose();
    } else {
      snackbar.current = snackbars.bookingFailure;
    }
    snackbar.current.text = result.message;
    setSnackbarOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setMemberId("");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleBookModal = () => {
    setModalOpen(true);
  };

  const classes = useStyles();
  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ marginLeft: 100, marginTop: 50 }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.current?.severity}>
          {snackbar.current?.text}
        </Alert>
      </Snackbar>
      <div style={{ float: "right", padding: "9px 0px 9px 20px" }}>
        {
          events[eventId]?.slots?.map((slot) => {
            if (slot.id === slotId) {
              nbrOfFree = slot.max - slot.count;
              nbrOfFree = nbrOfFree < 0 ? 0 : nbrOfFree;
            }
          })
        }

        {`Platser kvar: ${nbrOfFree}`}
        <Button variant="contained"
          color="primary"
          style={{ marginLeft: 20 }}
          onClick={handleBookModal}
          disabled={nbrOfFree <= 0}
        >
          + Boka
        </Button>
      </div>

      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="Boka tid"
        aria-describedby="Boka tid genom att ange medlemsnummer"
      >
        <div
          className={classes.modal}
        >
          <Paper className={classes.paper}>
            <Typography
              component='h6'
              variant='h6'
              color='primary'
              style={{ textAlign: 'left', marginBottom: 0 }}
            >{store?.name}
              {
                Object.keys(events).map((key) => {
                  const event = events[key];
                  if (event.id === eventId) {
                    return (
                      <Typography key={event.id} style={{ color: "black" }}>
                        {`${event.dateString}, kl ${slotId}`}
                      </Typography>
                    )
                  }
                })}
            </Typography>

            <Typography
              component='p'
              variant='body1'
            >
            </Typography>

            <form className={classes.root} noValidate autoComplete='off' onSubmit={handleBook}>
              <div style={{ marginTop: 20 }}>
                <TextField error={false} id='input-member-id' label="Medlemsnummer" value={memberId} onChange={e => setMemberId(e.target.value)} />
              </div>
              <div style={{ marginTop: 50, textAlign: 'right' }}>
                <Button
                  variant='text'
                  color='primary'
                  onClick={() => setModalOpen(false)}
                >
                  Avbryt
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  style={{ marginLeft: 20 }}
                  onClick={handleBook}
                >
                  Boka
                </Button>
              </div>

            </form>

          </Paper>
        </div>
      </Modal>
    </>
  )
};
export default BookButton;

const useStyles = makeStyles((theme) => ({
  tableRow: {
    "& :hover": {
      backgroundColor: '#ebebeb',
    }
  },
  unbook: {
    textAlign: 'center',
    cursor: "pointer",
    fontSize: "0.9rem",
    color: '#006564',
    "& :hover": {
      backgroundColor: '#006564'
    },
  },
  modal: {
    width: 600,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  laddar: {
    textAlign: "center",
    padding: 30,
    marginBottom: "100%",
    backgroundColor: "rgb(221,221,221)",
    borderRadius: 4,
    width: "30%",
    margin: "auto"
  },
  spanText: {
    color: "rgb(0 101 100)",
    fontWeight: 800
  },
}));